/**
 * Retailer has seen warehouse sale promo modal *
 */ export var HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22 = 'HAS_SEEN_WAREHOUSE_SALE_MODAL_NOV_22';
